export default __webpack_public_path__ + "static/media/meet4.29eb941f.png";